// Reading-time helpers for teleprompter timing.
// Base rate: 150 words per minute for Brazilian TV news pace.

const WORDS_PER_MIN = 150;

// Remove teleprompter markup (and its inner content) so command text
// like [apresentador], {RODA VT}, (crédito) and ((CAM1)) does not count
// toward reading time. Order matters: strip double-parens first.
const MARKUP_RE = /\(\([^()]*\)\)|\[[^\[\]]*\]|\{[^{}]*\}|\([^()]*\)/g;
export function stripPrompterMarkup(text) {
  if (!text) return "";
  return text.replace(MARKUP_RE, " ");
}

export function wordCount(text) {
  if (!text) return 0;
  return stripPrompterMarkup(text).trim().split(/\s+/).filter(Boolean).length;
}

export function readingSeconds(text) {
  return Math.round((wordCount(text) / WORDS_PER_MIN) * 60);
}

export function formatDuration(totalSeconds) {
  if (!totalSeconds || totalSeconds < 0) return "00:00";
  const s = Math.round(totalSeconds);
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${String(m).padStart(2, "0")}:${String(rem).padStart(2, "0")}`;
}

// Duration a single retranca contributes to the program.
// VTs use vt_duration (seconds); everything else uses reading time.
export function retrancaSeconds(r) {
  if (r.type === "VT" && r.vt_duration && r.vt_duration > 0) {
    return r.vt_duration;
  }
  return readingSeconds(r.text || "");
}

export function totalSeconds(retrancas, approvedOnly = false) {
  let total = 0;
  for (const r of retrancas || []) {
    if (approvedOnly && !r.approved) continue;
    total += retrancaSeconds(r);
  }
  return total;
}
